import { CardInformations } from "./styles";

const Card = ({ image, title, description }) => {
  return (
    <CardInformations>
      <img src={image} alt="imagem" />
      <h3>{title}</h3>
      <ul>
        {description.map((description, index) => (
          <li key={index}>{description.text}</li>
        ))}
      </ul>
    </CardInformations>
  );
};

export default Card;
